module.exports = __webpack_public_path__ + "img/image_part_006.635daf5d.jpg";